import { Link, Typography } from "@mui/material";
import { StyledFlex } from "Components/Shared/StyledComponents";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.SignUp.Form.Fields.AgreeWithTermsAndConditions
    .HunterEULACheckboxLabel;

export const HunterEULACheckboxLabel = () => {
  const { t } = useResource();

  return (
    <StyledFlex gap="5px">
      <Typography textAlign="justify">
        {t(COMPONENT_RESOURCES.StartText)}
        <Link
          target="_blank"
          href={`${getApiUrl()}${t(COMPONENT_RESOURCES.ContractUrl)}`}
          mx={1}
        >
          {t(COMPONENT_RESOURCES.ContractText)}
        </Link>
        {t(COMPONENT_RESOURCES.MiddleText)}
        <Link
          target="_blank"
          href={`${getApiUrl()}${t(COMPONENT_RESOURCES.RelatedDocsUrl)}`}
          ml={1}
        >
          {t(COMPONENT_RESOURCES.RelatedDocsText)}
        </Link>
        .
      </Typography>
    </StyledFlex>
  );
};
